// @core/api/endpoints/authn/sign_in_with_code.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SignInResponse,
  SignInWithCodeRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Sign in with one-time code
 * Authenticates a user using a one-time code sent to their email. Provides passwordless login and returns access and refresh tokens on successful verification.
 * @public This endpoint does not require authentication
 */
export async function SignInWithCode(
  data: SignInWithCodeRequest,
  options?: RequestOptions
): Promise<SignInResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/auth/signin/code`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<SignInResponse>(requestPath, data, requestOptions);
}
